import {
  BooleanField,
  DataTable,
  List,
  ListActions,
  NumberField,
  SearchInput,
} from "../common";

const filters = [<SearchInput key="q" source="q" alwaysOn />];

export const LeaveTypeList = () => (
  <List
    title="Leave Types"
    filters={filters}
    actions={<ListActions label="Add Leave Type" />}
    sort={{ field: "name", order: "ASC" }}
  >
    <div className="employees-table-container">
      <DataTable rowClick="edit" className="employees-table">
        <DataTable.Col source="code" label="Code" className="employee-code" />
        <DataTable.Col source="name" label="Leave Type" className="employee-name" />
        <DataTable.Col source="days_per_year" label="Days / Year">
          <NumberField source="days_per_year" />
        </DataTable.Col>
        <DataTable.Col source="paid" label="Paid">
          <BooleanField source="paid" />
        </DataTable.Col>
        <DataTable.Col source="carry_forward" label="Carry Forward">
          <BooleanField source="carry_forward" />
        </DataTable.Col>
      </DataTable>
    </div>
  </List>
);

